import './styles/styles.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import AppNoAuth from './AppNoAuth'
import Keycloak from 'keycloak-js'
import axios from 'axios'
import registerServiceWorker from './registerServiceWorker'
import configureStore from './store/configureStore'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

const store = configureStore()

const kc = Keycloak('/keycloak.json')
kc.init({onLoad: 'check-sso', checkLoginIframe: false}).success(authenticated => {
  if (authenticated) {
    setInterval(() => {
      kc.updateToken(10).error(() => kc.logout())
    }, 10000)


      const handleLogout = (keycloak) => {
          localStorage.removeItem('selectedLocation')
          localStorage.removeItem('selectedUnit')
          kc.logout({
              redirectUri: window.location.origin
          })
      }

    ReactDOM.render(<Provider store={store}>
      <BrowserRouter>
        <App store={store} keycloakSession={kc} onLogout={() => handleLogout(kc)} />
      </BrowserRouter>
    </Provider>, document.getElementById('root'))
  } else {
    // Pagina's zonder authenticatie
    ReactDOM.render(<Provider store={store}>
      <BrowserRouter>
        <AppNoAuth store={store} keycloakSession={kc} />
      </BrowserRouter>
    </Provider>, document.getElementById('root')) }
});


axios.interceptors.request.use(config => {
  config.headers = {...config.headers, ...{
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: 'Bearer ' + kc.token
  }};
  return config
});

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.status === 401) {
    kc.login()
  } else if (error.response.status === 500) {
    store.dispatch({type: 'SERVER_ERROR', data: {status: error.status, statusText: error.statusText, response: error.response.data}})
  }
  return Promise.reject(error)
})

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js